<template>
  <div>
    <table class="paiements" v-if="sales">
      <tr v-if="sales.length">
        <th>Date Création</th>
        <th>Achats</th>
        <th>Pseudo</th>
        <th>Ref</th>
        <th>Montant</th>
      </tr>
      <tr class="paiement" v-for="sal in sales" :key="sal.id">
        <td>{{ sal.user.textCreationDate }}</td>
        <td>{{ achats(sal.user) }}</td>

        <td>
          <a target="_blank" class="pinkLink" :href="`/admin/admin_users.jsp?p=${sal.user.pseudo}`">
            {{ sal.user.pseudo }}
          </a>
        </td>
        <td>{{ sal.ref }}</td>
        <td>{{ sal.price }}</td>
        <td>
          <a @click.prevent="valid(sal.id, i)" class="bouton">Valider</a>
        </td>
        <td>
          <a @click.prevent="ban(sal.user)" class="bouton">Bannir</a>
        </td>
      </tr>
    </table>

    <div v-if="sales && !sales.length">Aucun paiement à capturer</div>
  </div>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  components: {},

  data() {
    return { sales: null };
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.sales = await idyuJsonRpc("getSalesToCapture");
      for (let sal of this.sales) {
        sal.user = await idyuJsonRpc("getUserById", sal.idUser);
        sal.user.textCreationDate = new Date(sal.user.creationDate).toLocaleDateString();
        sal.user.sales = await idyuJsonRpc("getAllPayments", sal.user.id);
      }
    },

    async valid(id, i) {
      let res = await idyuJsonRpc("captureSales", id);
      if (res != 1) {
        await alert("Echec d'encaissement du paiment.");
      }
      this.sales.splice(i, 1);
    },

    async ban(usr) {
      if (await confirm(`Etes-vous sur de vouloir bannir ${usr.pseudo} ?`)) {
        let res = await idyuJsonRpc("banProfile", usr.idProfile);
        if (res != 1) {
          await alert("Impossible de bannir cet utilisateur.");
        }
        for (let i = 0; i < this.sales.length; i++) {
          let sal = this.sales[i];
          if (sal.user.id == usr.id) {
            this.sales.splice(i, 1);
            i = 0;
          }
        }
      }
    },

    achats(user) {
      let res = 0;
      let now = new Date();
      now = now.getTime();
      for (let sal of user.sales) {
        if (now - sal.date >= 1000 * 60 * 60 * 24 * 30) {
          res += sal.price;
        }
      }
      return res.toFixed(2);
    }
  }
};
</script>

<style scoped lang="scss">
a.bouton {
  padding-left: 20px;
  padding-right: 20px;
}
</style>
